import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    sites: [
      {
        id: "taipei-uuid",
        name: "Taipei",
        siteRoleId: 9,
        siteRoleName: "Admin"
      },
      {
        id: "kaohsiung-uuid",
        name: "Kaohsiung",
        siteRoleId: 9,
        siteRoleName: "Admin"
      }
    ]
  }
};

export const scopeLevelSlice = createSlice({
  name: "scopeLevel",
  initialState,
  reducers: {
    addScopeLevelSite: (state, action) => {
      state.data.sites.push(action.payload);
    },
  },
});

export const { addScopeLevelSite } = scopeLevelSlice.actions;

export default scopeLevelSlice.reducer;